import type { RouteObject } from "react-router-dom";
import { lazy } from "react";
import NotFound from "../pages/NotFound";

const Home = lazy(() => import("../pages/home/page"));
const About = lazy(() => import("../pages/about/page"));
const Services = lazy(() => import("../pages/services/page"));
const Funders = lazy(() => import("../pages/funders/page"));
const Borrowers = lazy(() => import("../pages/borrowers/page"));
const Process = lazy(() => import("../pages/process/page"));
const Cases = lazy(() => import("../pages/cases/page"));
const Contact = lazy(() => import("../pages/contact/page"));
const FAQ = lazy(() => import("../pages/faq/page"));
const LoginPage = lazy(() => import('../pages/login/page'));
const DashboardPage = lazy(() => import('../pages/dashboard/page'));
const TestEmailPage = lazy(() => import('../pages/test-email/page'));
const TestLinePage = lazy(() => import('../pages/test-line/page'));
const GetLineUserIdPage = lazy(() => import('../pages/get-line-userid/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));

// 方案詳情頁面
const YouthStartupPage = lazy(() => import('../pages/projects/youth-startup/page'));
const CreditGuaranteePage = lazy(() => import('../pages/projects/credit-guarantee/page'));
const LowCarbonPage = lazy(() => import('../pages/projects/low-carbon/page'));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/services",
    element: <Services />,
  },
  {
    path: "/funders",
    element: <Funders />,
  },
  {
    path: "/borrowers",
    element: <Borrowers />,
  },
  {
    path: "/process",
    element: <Process />,
  },
  {
    path: "/cases",
    element: <Cases />,
  },
  {
    path: "/contact",
    element: <Contact />,
  },
  {
    path: "/faq",
    element: <FAQ />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicyPage />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfServicePage />,
  },
  {
    path: "/dashboard",
    element: <LoginPage />,
  },
  {
    path: "/admin/dashboard",
    element: <DashboardPage />,
  },
  {
    path: "/test-email",
    element: <TestEmailPage />,
  },
  {
    path: "/test-line",
    element: <TestLinePage />,
  },
  {
    path: "/get-line-userid",
    element: <GetLineUserIdPage />,
  },
  // 方案詳情頁面路由
  {
    path: "/projects/youth-startup",
    element: <YouthStartupPage />,
  },
  {
    path: "/projects/credit-guarantee",
    element: <CreditGuaranteePage />,
  },
  {
    path: "/projects/low-carbon",
    element: <LowCarbonPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;